<template>
  <Form
    :key="formKey"
    ref="form"
    class="add-input"
    @submitю.prevent="onEnter"
  >
    <BasicInput
      ref="basicInput"
      id="addCustomInput"
      v-model="value"
      placeholder="Add Custom..."
      class="add-input__item"
      name="addCustomInput"
      :rules="rules"
    />
    <button
      type="submit"
      @click="onEnter"
    >
      <icon
        data="@icon/plus.svg"
        color="#336DFF"
        width="1.5em"
        height="1.5em"
      />
    </button>
  </Form>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop, Ref } from "vue-property-decorator"
import { Form } from "vee-validate"

import BasicInput from "@/components/Form/BasicInput.vue"

@Options({
  name: "AddBasicInput",
  components: {
    BasicInput,
    Form
  }
})
export default class AddBasicCheckbox extends Vue {
  @Prop({ default: null }) readonly rules!: ((value: any) => boolean | string) | null

  @Ref("form") readonly form
  @Ref("basicInput") readonly basicInput

  value = ""
  formKey = 0

  async onEnter() {
    if (this.rules) {
      const { valid } = await this.form.validate()
      if (!valid) return
    }

    this.$emit("enter", this.value)
    this.value = ""
    this.formKey++
  }
}
</script>
